/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import MiscFeeSettingsOfficeContent from './MiscFeeSettingsOfficeContent';
import useDebounce from '../../../../common/components/UseDebounce';

import CreateModal from './modal/CreateModal';
import UpdateModal from './modal/UpdateModal';

import * as actions from '../../action';
import * as c from '../../constant';

const form = {
  keyword: '',
};

function MiscFeeSettingsOfficeContainer({
  match,
  history,
  getMiscFeeSettingsOfficeList,
  settingsList,
  settingsListPager,
  isLoading,
  deleteMiscFeeSettingsOffice,
  showMiscFeeSettingsOffice,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal/>,
      title: 'Add Office',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Edit Office',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this item?',
      () => {
        deleteMiscFeeSettingsOffice(data.id, () => {
          getMiscFeeSettingsOfficeList(c.IS_ACTIVE, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/miscellaneous-fees/settings/office/${id}`);
            showMiscFeeSettingsOffice(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getMiscFeeSettingsOfficeList(c.IS_ACTIVE);
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    is_paginated: 1,
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getMiscFeeSettingsOfficeList({ 
        ...c.IS_ACTIVE, 
        ...param, 
        sort_by: 'desc' 
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:userManagementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Offices List"
            getData={getMiscFeeSettingsOfficeList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:userManagementId?`}
            listName="Miscellaneous Fees"
            label="Offices List"
            renderItem={(item) => (
              <p className="px-3 my-auto text-uppercase">
                {_.get(item, 'attributes.name')}{' '}
              </p>
            )}
            isLoading={isLoading}
            selected={params.userManagementId}
            data={settingsList}
            dataPager={settingsListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderTopContent={() => {
              return (
                <div className="row pr-3 py-2 mb-2">
                  <div className="col-12 d-flex ">
                    <button
                      type="button"
                      onClick={handleAddModal}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    >
                      <i className="fas fa-plus" />
                      {" "}Add Office
                    </button>
                  </div>
                </div>
              )
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:userManagementId?`}
                    render={() => (
                      <MiscFeeSettingsOfficeContent
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:userManagementId?`}
                  render={() =>
                    !params.userManagementId && settingsList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(settingsList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

MiscFeeSettingsOfficeContainer.defaultProps = {
  deleteMiscFeeSettingsOffice: () => {},
};

MiscFeeSettingsOfficeContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMiscFeeSettingsOfficeList: PropTypes.instanceOf(Function).isRequired,
  settingsList: PropTypes.instanceOf(Array).isRequired,
  settingsListPager: PropTypes.instanceOf(Object).isRequired,
  deleteMiscFeeSettingsOffice: PropTypes.instanceOf(Function),
  isLoading: PropTypes.bool.isRequired,
  showMiscFeeSettingsOffice: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  settingsList: _.get(api, `${c.GET_MISC_FEE_SETTINGS_OFFICES_LIST}.list`) || [],
  settingsListPager:
    _.get(api, `${c.GET_MISC_FEE_SETTINGS_OFFICES_LIST}.pager`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MISC_FEE_SETTINGS_OFFICES_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MiscFeeSettingsOfficeContainer);
